import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import apiClient from "../../api/client";
import { useAuth } from "../../context/AuthContext";

const AdminRoute = ({ children }) => {
  const { token } = useAuth();
  const [state, setState] = useState({
    loading: true,
    allowed: false,
  });

  useEffect(() => {
    let cancelled = false;

    const checkAdmin = async () => {
      try {
        // Get the auth token and make the request with proper headers
        const authToken = token || localStorage.getItem('token');
        
        if (!authToken) {
          console.log("[AdminRoute] ⚠️ No auth token found");
          if (!cancelled) {
            setState({ loading: false, allowed: false });
          }
          return;
        }

        const res = await apiClient.get("/auth/me", {
          headers: {
            Authorization: `Bearer ${authToken}`
          }
        });
        
        if (cancelled) return;

        const isAdmin = !!res.data?.is_admin;
        console.log("[AdminRoute] 🔍 Admin check result:", {
          email: res.data?.email,
          is_admin: res.data?.is_admin,
          allowed: isAdmin
        });
        setState({ loading: false, allowed: isAdmin });
      } catch (err) {
        console.error("[AdminRoute] Failed to check admin:", err);
        if (!cancelled) {
          setState({ loading: false, allowed: false });
        }
      }
    };

    checkAdmin();

    return () => {
      cancelled = true;
    };
  }, [token]);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <div className="text-sm text-slate-400">
          Checking admin access…
        </div>
      </div>
    );
  }

  if (!state.allowed) {
    // Not an admin → send them back to dashboard
    console.log("[AdminRoute] ❌ Access denied - redirecting to dashboard");
    return <Navigate to="/dashboard" replace />;
  }

  // User is admin → render admin content
  console.log("[AdminRoute] ✅ Admin access granted");
  return <>{children}</>;
};

export default AdminRoute;
